import React from 'react';
import Button from 'src/components/Button/Button';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import {
  StepId,
  WIZARD_STEP_PICK,
  WIZARD_STEP_REVIEW,
  WIZARD_STEP_CONFIRMATION,
} from 'src/components/ContactsTable/EmailSelfServiceDialogue/CustomHooks/useEmailSelfServiceFormState/useEmailSelfServiceFormState';
import './email-self-service-footer.scss';

interface EmailSelfServiceFooterProps {
  currentStep: StepId;
  canContinue: boolean;
  canApply: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onBack: () => void;
  onContinue: () => void;
  onApply: () => void;
  onDone: () => void;
}

const EmailSelfServiceFooter = ({
  currentStep,
  canContinue,
  canApply,
  isSubmitting,
  onCancel,
  onBack,
  onContinue,
  onApply,
  onDone,
}: EmailSelfServiceFooterProps) => {
  if (currentStep === WIZARD_STEP_PICK) {
    return (
      <div className="essf-footer">
        <div className="essf-footer-left" />
        <div className="essf-footer-right">
          <Button
            color="white"
            size="small"
            label="Cancel"
            onClick={onCancel}
          />
          <Button
            color="teal"
            size="small"
            label="Next"
            onClick={onContinue}
            disabled={!canContinue}
          />
        </div>
      </div>
    );
  }

  if (currentStep === WIZARD_STEP_REVIEW) {
    return (
      <div className="essf-footer">
        <div className="essf-footer-left">
          <Button
            color="white"
            size="small"
            label="← Back"
            onClick={onBack}
            disabled={isSubmitting}
          />
        </div>
        <div className="essf-footer-right">
          <Button
            color="white"
            size="small"
            label="Cancel"
            onClick={onCancel}
            disabled={isSubmitting}
          />
          <LoadingButton
            actionText="Apply changes"
            isSubmitting={isSubmitting}
            disabled={!canApply}
            onClick={onApply}
          />
        </div>
      </div>
    );
  }

  if (currentStep === WIZARD_STEP_CONFIRMATION) {
    return (
      <div className="essf-footer">
        <div className="essf-footer-left" />
        <div className="essf-footer-right">
          <Button color="teal" size="small" label="Done" onClick={onDone} />
        </div>
      </div>
    );
  }

  return null;
};

export default EmailSelfServiceFooter;
